import * as Sentry from "@sentry/react"

const userAuthenticated = window.location.pathname.includes("/login")
Sentry.init({
  dsn: "https://393f701a4e1b41fcabdeff40dcdd0017@o4509585010196480.ingest.us.sentry.io/4509710409990144",
  ...(userAuthenticated
    ? {}
    : {
        tunnel: `${process.env.REACT_APP_API_URL?.replace(
          /\/+$/,
          ""
        )}/tunnel/sentry`
      }), //  Route defined
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  tracesSampleRate: process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || 0.0,
  environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || "local",
  release: process.env.REACT_APP_SENTRY_RELEASE || "placeholder",
  // Session Replay configuration
  replaysSessionSampleRate:
    process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || 0.0,
  replaysOnErrorSampleRate:
    process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || 0.0,
  // Filter out 4xx client errors in beforeSend ( validation/client errors, not bugs )
  beforeSend(event, hint) {
    const status =
      hint.originalException?.response?.status ||
      hint.originalException?.status ||
      event.contexts?.response?.status_code
    if (status >= 400 && status < 500) {
      return null
    }
    return event
  },
  // Ignore "Failed to fetch" and Network Errors(common when dev API is down)
  ignoreErrors: [
    "Failed to fetch",
    "NetworkError when attempting to fetch resource"
  ],
  integrations: [
    Sentry.browserTracingIntegration(),
    // unmask all text and media in session replay
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false
    }),
    Sentry.graphqlClientIntegration({
      endpoints: [/\/graphql$/]
    }),
    // hide default feedback floating button
    Sentry.feedbackIntegration({
      themeLight: {
        accentBackground: "#3c4dac",
        accentForeground: "#EDEDED"
      },
      colorScheme: "light",
      autoStart: false,
      autoInject: false
    })
  ],
  tracePropagationTargets: [
    // Local development URLs
    /^https?:\/\/(0\.0\.0\.0|127\.0\.0\.1|localhost)(:\d+)?(\/graphql)?$/,
    // Visual Alpha domains (production, dev, staging, review-apps)
    /^https:\/\/.*\.visual-alpha\.com.*\/graphql$/
  ]
})
